export const pictureMinxin = {
    data() {
        // 这里存放数据
        return {
            picShow: false,
            pictures: [],
            bigPic: require('@/assets/png/noImage.png'),
            state: 0,
            checked: 0,
            checkedPic: 0,
            changePicturesMap: null,
            isExistence: false
        }
    },
    methods: {
        add() {
            let pics = this.changePicturesMap.get(this.checked)
            if (this.checkedPic + 1 < pics.length) {
                let v = this.checkedPic + 1
                this.checkedPicPoint(pics[v], v)
            }
        },
        reduce() {
            let pics = this.changePicturesMap.get(this.checked)
            if (this.checkedPic > 0) {
                let v = this.checkedPic - 1
                this.checkedPicPoint(pics[v], v)
            }
        },
        checkedPicPoint(pic,index) {
            this.checkedPic = index
            let container = document.getElementById("photoWall")
            var elementsByClassNameElement = document.getElementsByClassName("picKuai")[index];
            // 水平滚动
            let x = elementsByClassNameElement.offsetLeft - container.clientWidth + container.clientWidth/2 + elementsByClassNameElement.clientWidth/2;
            container.scrollTo({
                left: x,
                behavior: "smooth",
            });
            this.bigPic = pic
        },
        init(pictures,state) {
            this.picShow = true
            if (pictures && pictures.length > 0) {
                this.pictures = pictures
                this.bigPic = pictures[0].path
                this.state = state
                let p = new Map();
                p.set(0, this.pictures.map(x => x.path))
                p.set(1, this.pictures.filter(c => c.name&&c.name === "外观").map(x => x.path))
                p.set(2, this.pictures.filter(c => c.name&&c.name === "房间").map(x => x.path))
                p.set(3, this.pictures.filter(c => c.name&&c.name === "公共").map(x => x.path))
                p.set(4, this.pictures.filter(c => c.name&&c.name !== "外观" && c.name !== "房间" && c.name !== "公共").map(x => x.path))
                this.changePicturesMap = p
                this.isExistence = true
            }
        },
        pointLi(v) {
            this.checked = v
            this.checkedPic = 0
        },
        photoWallScroll(e) {
            e.scrollLeft = 10
        }
    },
}